<template>
	<div>
		<div class="preloader" v-if="false">
			<div class="preloader-icon"></div>
		</div>
		<div class="layout-wrapper">
			<top></top>
			<div class="content-wrapper">
				<!-- <navigation></navigation> -->
				<div class="content-body">
					<div class="content">
						<!-- <div class="page-header">
							<nav aria-label="breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item">
										<a href="javascript:;">{{routes.find(d=>d.path==$route.matched[0].path).name}}</a>	
									</li>
						
									<li class="breadcrumb-item active" aria-current="page">{{$route.name}}</li>
								</ol>
							</nav>
						</div> -->
						<router-view :key="key"></router-view>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Top,
		Navigation
	} from './components'
	import request from '@/utils/request'
	export default {
		name: 'Layout',
		components: {
			Top,
			Navigation
		},
		computed: {
			'routes': vm => vm.$router.options.routes,
			key() {
				return this.$route.path + Math.random()
			}

		},
		created() {
			if (!this.$store.state.token) {
				this.$router.push("/login")
			}
			setTimeout(()=>{
				if (!this.$store.state.token) {
					this.$router.push("/login")
				}
			},3000);
			request({
				// url: '/shop/user/getinfo',
				url: 'DRPAPI.ashx?a=getuserinfo',
				method: 'get',
				data: {}
			}).then(res => {
				if (res.code == 200) {
					this.$store.state.user = res.data
				}
			})
		}
	}
</script>

<style>
	@import "~@/vendors/bundle.css";
	@import "~@/css/app.css";
	.content{
		padding-left: 30px !important;
		padding-top: 90px !important;
	}
</style>
